// extracted by mini-css-extract-plugin
module.exports = {"container":"VehiclesDevicesTab_container__a2DhZ"};